import { PaperClipIcon } from "Assets/icons/v2";
import React, { useEffect, useRef, useState } from "react";
import { useUploadFileMutation } from "store/services/utility";
import LoadingIndicator from "../LoadingIndicator";

const FileDocUpload = ({ onChange, text = "Upload" }) => {
    const fileRef = useRef();
    const [fileName, setFileName] = useState("");
    const [uploadFile, { isLoading }] = useUploadFileMutation()

    const handleClick = () => {
        fileRef.current.click();
    };

    const handleChange = async (e) => {
        const file = e.target.files[0];

        if (!file) return;

        try {
            let uploadedFileName = await uploadFile({ file: file, acl: "public-read" }).unwrap();
            console.log("uploadedFileName", uploadedFileName);

            if (uploadedFileName) {
                onChange(uploadedFileName);
                setFileName(uploadedFileName);
            }
        } catch (err) {
            console.error(err);
        }

        // ✅ reset file input so same file can be uploaded again
        e.target.value = "";
    };

    return (
        <div style={styles.wrapper} onClick={handleClick}>
            {
                isLoading ? <LoadingIndicator color="#ffffff" /> :
                    <div className="d-flex gap-2">
                        <span style={styles.fileText}>
                            {text}
                        </span>
                        <PaperClipIcon stroke="#ffffff" />
                    </div>
            }
            <input
                ref={fileRef}
                type="file"
                onChange={handleChange}
                style={{ display: "none" }}
            />
        </div>
    );
};

export default FileDocUpload;

const styles = {
    wrapper: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px 14px",
        width: "fit-content",
        background: "#315d99",
        cursor: "pointer",
        minWidth: "150px",
        minHeight: "40px"

    },

    fileText: {
        color: "#fff",
        fontSize: "14px",
        fontWeight: 700,
    },
};
